import { render, staticRenderFns } from "./onlineTraining.vue?vue&type=template&id=4c8214b0&scoped=true&"
import script from "./onlineTraining.vue?vue&type=script&lang=js&"
export * from "./onlineTraining.vue?vue&type=script&lang=js&"
import style0 from "./onlineTraining.vue?vue&type=style&index=0&id=4c8214b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8214b0",
  null
  
)

export default component.exports